import { combineReducers } from 'redux';
import infoReducers from './info/containers/info-reducer';

export default combineReducers({
  info: infoReducers,
});
